export default "__VITE_ASSET__D39qf5ZJ__"